import styled from "styled-components"

export const ContainerModal = styled.div`
    .modalOverlay{
        cursor: default;
        z-index: 9;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100vh;
        background-color: rgba(0,0,0,0.8);
        border: none;
        overflow: auto;
        visibility: hidden;
        opacity: 0;
        transition: .4s;
    }
    .modalContent{
        box-sizing: border-box;
        z-index: 9999;
        position: fixed;
        top: -140vh;
        left: calc(50% - 250px);
        width: 500px;
        max-height: 90vh;
        padding: 50px;
        background-color: #FFF;
        border-radius: 5px;
        box-shadow: 0px 7px 6px #00000029;
        transition-delay: .8s;
        transition: .8s;
        overflow: auto;
    }
    .modalFooter{
        display: flex;
        gap: 12px;
        margin-top: 12px;
        .btn {
            margin: 0;
        }
    }
    &.active{
        .modalOverlay{
            visibility: visible;
            opacity: 1;
        }
        .modalContent{
            top: 50px;
            animation-name: backInDown;
            animation-duration: 1s;
        }
    }
    @media (min-width: 600px){
        .modalContent{
            .header-mobile{
                padding-top: 10px;
                .btn-back{
                    display: none;
                }
            }
        }
    }
    @media (max-width: 600px){
        .modalContent{
            width: calc(100% - 40px);
            position: fixed;
            left: 3%;
            min-width: 94%;
            max-height: calc(100vh - 4%);
        }
        &.active{
            .modalContent{
                top: 2%;
            }
        }
    }
`